// growthos/warchest-frontend/react-app/src/Components/v2/atoms/ActivityItems/ScenarioSubmittedActivity.tsx
import ImportExportOutlinedIcon from "@mui/icons-material/ImportExportOutlined";
import { useTheme } from "@mui/material";
import React from "react";

import { Box } from "@/Components/v2/atoms/Box";
import { Typography } from "@/Components/v2/atoms/Typography";
import { ActivityEventEnum } from "@/pages/scenario-builder/types";
import { getUserName } from "@/pages/scenario-builder/utils/convertToActivity";

import { ActivityItemWrapper, IconContainer, IconWrapper } from "./shared/StyledComponents";
import { Activity } from "./types";

export const ScenarioSubmittedActivity: React.FC<{
  activity: Extract<Activity, { eventType: ActivityEventEnum.ScenarioSubmitted }>;
}> = ({ activity }) => {
  const theme = useTheme();
  return (
    <ActivityItemWrapper>
      <IconContainer>
        <IconWrapper>
          <ImportExportOutlinedIcon
            sx={{ fontSize: "2rem", paddingRight: "5px", paddingTop: "5px" }}
          />
        </IconWrapper>
      </IconContainer>
      <Box>
        <Typography variant="body2">Scenario was submitted for modeling</Typography>
        <Typography fontSize={12} sx={{ color: theme.palette.activityLog.user }}>
          {getUserName(activity.user)}
        </Typography>
      </Box>
    </ActivityItemWrapper>
  );
};
